import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";

import MainHeader from "../../components/MainHeader";
import api from "../../services/api";
import usePlans from "../../hooks/usePlans";
import { i18n } from "../../translate/i18n";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Chip,
} from "@material-ui/core";
import ForbiddenPage from "../../components/ForbiddenPage";
import TuneIcon from "@material-ui/icons/Tune";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  pageHeader: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 16,
    color: "#1e2a44",
    background: "#EDF4FF",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
  },
  pageHeaderTitle: {
    fontWeight: 600,
    letterSpacing: 0.1,
    fontSize: "1.2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05rem",
    },
  },
  pageHeaderSubtitle: {
    marginTop: theme.spacing(0.25),
    color: "rgba(30,42,68,0.78)",
    fontSize: "0.8rem",
    lineHeight: 1.35,
  },
  headerChip: {
    backgroundColor: "#EAF1FF",
    color: "#2f4b7c",
    border: "1px solid #d7e5ff",
    fontWeight: 500,
    fontSize: "0.72rem",
    height: 24,
  },
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1.25),
    overflowY: "auto",
    ...theme.scrollbarStyles,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
  },
  textRight: {
    textAlign: "right",
  },
  sectionTitle: {
    fontSize: "0.86rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  actionButton: {
    minHeight: 42,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "0.75rem",
    padding: theme.spacing(0.8, 1.4),
    boxShadow: "0 6px 14px rgba(7, 64, 171, 0.14)",
  },
  tabPanelsContainer: {
    padding: theme.spacing(0.5),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },


  premiumRoot: {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100%",
    height: "auto",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(8)
    }
  },
  premiumHero: {
    borderRadius: 24,
    padding: theme.spacing(2.1),
    background: "linear-gradient(135deg, #071B4D 0%, #005BFF 58%, #00A3FF 100%)",
    color: "#fff",
    boxShadow: "0 24px 58px rgba(0,102,255,0.22)",
    display: "grid",
    gridTemplateColumns: "1fr 360px",
    gap: theme.spacing(2),
    alignItems: "center",
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
    [theme.breakpoints.down("sm")]: {
      borderRadius: 20,
      padding: theme.spacing(1.6)
    }
  },
  premiumHeroLeft: {
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "center"
  },
  premiumHeroIcon: {
    width: 58,
    height: 58,
    borderRadius: 18,
    background: "rgba(255,255,255,.16)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    flexShrink: 0
  },
  premiumHeroTitle: {
    fontWeight: 950,
    fontSize: "1.65rem",
    color: "#fff",
    lineHeight: 1.08,
    [theme.breakpoints.down("sm")]: { fontSize: "1.25rem" }
  },
  premiumHeroSubtitle: {
    fontSize: ".84rem",
    opacity: .86,
    marginTop: 6,
    lineHeight: 1.45,
    [theme.breakpoints.down("sm")]: { fontSize: ".74rem" }
  },
  premiumMetrics: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1)
  },
  premiumMetric: {
    borderRadius: 18,
    padding: theme.spacing(1.3),
    background: "rgba(255,255,255,.14)",
    border: "1px solid rgba(255,255,255,.20)"
  },
  premiumMetricValue: {
    fontWeight: 950,
    fontSize: "1.2rem",
    color: "#fff"
  },
  premiumMetricLabel: {
    fontSize: ".68rem",
    opacity: .78,
    fontWeight: 800,
    marginTop: 3
  },
  configPanel: {
    borderRadius: 24,
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 14px 30px rgba(15,23,42,0.07)"
  },
  configGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(1.4),
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" }
  },
  configCard: {
    borderRadius: 20,
    padding: theme.spacing(1.5),
    background: theme.palette.type === "dark" ? "rgba(255,255,255,.04)" : "#F8FAFC",
    border: `1px solid ${theme.palette.divider}`
  },
  configCardTitle: {
    fontWeight: 950,
    fontSize: ".88rem",
    marginBottom: theme.spacing(1),
    color: theme.palette.type === "dark" ? "#fff" : "#0F172A"
  },
  configSelect: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      background: theme.palette.background.paper
    }
  },
  saveArea: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      "& button": { width: "100%" }
    }
  }

}));

const initialSettings = {
  messageInterval: 20,
  longerIntervalAfter: 20,
  greaterInterval: 60,
  variables: [],
  sabado: "false",
  domingo: "false",
  startHour: "09:00",
  endHour: "18:00"
};

const CampaignsConfig = () => {
  const classes = useStyles();
  const history = useHistory();

  const [settings, setSettings] = useState(initialSettings);
  const { user } = useContext(AuthContext);

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (
        false &&
        !planConfigs.plan.useCampaigns
      ) { /* KORAX_COMMON_CAMPAIGNS */
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.get("/campaign-settings").then(({ data }) => {
      const settingsList = [];
      console.log(data)
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((item) => {
          settingsList.push([item.key, item.value]);
        });
        setSettings(Object.fromEntries(settingsList));
      }
    });
  }, []);

  const handleOnChangeSettings = (e) => {
    const changedProp = {};
    changedProp[e.target.name] = e.target.value;
    setSettings((prev) => ({ ...prev, ...changedProp }));
  };

  const saveSettings = async () => {
    await api.post("/campaign-settings", { settings });
    toast.success("Configurações salvas");
  };

  return (
    <div className={classes.pageRoot}>
      {
        user.profile === "user" ?
          <ForbiddenPage />
          :
          <div className={classes.premiumRoot}>
            <section className={classes.premiumHero}>
              <div className={classes.premiumHeroLeft}>
                <div className={classes.premiumHeroIcon}>⚙️</div>
                <div>
                  <Typography className={classes.premiumHeroTitle}>
                    Configurações de Disparo
                  </Typography>
                  <Typography className={classes.premiumHeroSubtitle}>
                    Ajuste intervalos, pausas inteligentes e segurança operacional das campanhas.
                  </Typography>
                </div>
              </div>

              <div className={classes.premiumMetrics}>
                <div className={classes.premiumMetric}>
                  <Typography className={classes.premiumMetricValue}>{settings.messageInterval}s</Typography>
                  <Typography className={classes.premiumMetricLabel}>Intervalo</Typography>
                </div>
                <div className={classes.premiumMetric}>
                  <Typography className={classes.premiumMetricValue}>{settings.longerIntervalAfter}</Typography>
                  <Typography className={classes.premiumMetricLabel}>Mensagens antes da pausa</Typography>
                </div>
              </div>
            </section>

            <Paper className={classes.configPanel} variant="outlined">
              <Typography style={{ fontWeight: 950, fontSize: ".98rem", marginBottom: 14 }}>
                Parâmetros de envio responsável
              </Typography>

              <div className={classes.configGrid}>
                <div className={classes.configCard}>
                  <Typography className={classes.configCardTitle}>⚡ Intervalo padrão</Typography>
                  <FormControl variant="outlined" fullWidth className={classes.configSelect}>
                    <InputLabel id="messageInterval-label">
                      {i18n.t("campaigns.settings.randomInterval")}
                    </InputLabel>
                    <Select
                      name="messageInterval"
                      id="messageInterval"
                      labelId="messageInterval-label"
                      label={i18n.t("campaigns.settings.randomInterval")}
                      value={settings.messageInterval}
                      onChange={(e) => handleOnChangeSettings(e)}
                    >
                      <MenuItem value={0}>{i18n.t("campaigns.settings.noBreak")}</MenuItem>
                      <MenuItem value={5}>5 segundos</MenuItem>
                      <MenuItem value={10}>10 segundos</MenuItem>
                      <MenuItem value={15}>15 segundos</MenuItem>
                      <MenuItem value={20}>20 segundos</MenuItem>
                      <MenuItem value={30}>30 segundos</MenuItem>
                      <MenuItem value={60}>60 segundos</MenuItem>
                      <MenuItem value={80}>80 segundos</MenuItem>
                      <MenuItem value={100}>100 segundos</MenuItem>
                      <MenuItem value={120}>120 segundos</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.configCard}>
                  <Typography className={classes.configCardTitle}>📨 Pausa após quantidade</Typography>
                  <FormControl variant="outlined" fullWidth className={classes.configSelect}>
                    <InputLabel id="longerIntervalAfter-label">
                      {i18n.t("campaigns.settings.intervalGapAfter")}
                    </InputLabel>
                    <Select
                      name="longerIntervalAfter"
                      id="longerIntervalAfter"
                      labelId="longerIntervalAfter-label"
                      label={i18n.t("campaigns.settings.intervalGapAfter")}
                      value={settings.longerIntervalAfter}
                      onChange={(e) => handleOnChangeSettings(e)}
                    >
                      <MenuItem value={0}>{i18n.t("campaigns.settings.undefined")}</MenuItem>
                      <MenuItem value={5}>5 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={10}>10 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={15}>15 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={20}>20 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={30}>30 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={40}>40 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={50}>50 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      <MenuItem value={60}>60 {i18n.t("campaigns.settings.messages")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.configCard}>
                  <Typography className={classes.configCardTitle}>⏱️ Intervalo longo</Typography>
                  <FormControl variant="outlined" fullWidth className={classes.configSelect}>
                    <InputLabel id="greaterInterval-label">
                      {i18n.t("campaigns.settings.laggerTriggerRange")}
                    </InputLabel>
                    <Select
                      name="greaterInterval"
                      id="greaterInterval"
                      labelId="greaterInterval-label"
                      label={i18n.t("campaigns.settings.laggerTriggerRange")}
                      value={settings.greaterInterval}
                      onChange={(e) => handleOnChangeSettings(e)}
                    >
                      <MenuItem value={0}>{i18n.t("campaigns.settings.noBreak")}</MenuItem>
                      <MenuItem value={20}>20 segundos</MenuItem>
                      <MenuItem value={30}>30 segundos</MenuItem>
                      <MenuItem value={40}>40 segundos</MenuItem>
                      <MenuItem value={50}>50 segundos</MenuItem>
                      <MenuItem value={60}>60 segundos</MenuItem>
                      <MenuItem value={90}>90 segundos</MenuItem>
                      <MenuItem value={120}>120 segundos</MenuItem>
                      <MenuItem value={150}>150 segundos</MenuItem>
                      <MenuItem value={180}>180 segundos</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className={classes.saveArea}>
                <Button
                  onClick={saveSettings}
                  color="primary"
                  variant="contained"
                  className={classes.actionButton}
                  style={{ borderRadius: 14, fontWeight: 900, textTransform: "none" }}
                >
                  Salvar configurações
                </Button>
              </div>
            </Paper>
          </div>
      }
    </div>
  );
};

export default CampaignsConfig;
